import React from 'react';
import { Link } from 'react-router-dom';

import verdLogo from '../../images/verd_logo_transparent_black.png';

const PrivacyPolicy = () => {
  return (
    <div className="tw-min-h-screen tw-bg-[#f5f7f8] tw-text-[#252b2e]">
      <header className="tw-sticky tw-top-0 tw-z-10 tw-border-b tw-border-[#dde3e5] tw-bg-white/95 tw-backdrop-blur-[10px]">
        <div className="tw-mx-auto tw-flex tw-min-h-16 tw-w-[calc(100%-1.75rem)] tw-max-w-[1080px] tw-items-center tw-justify-between sm:tw-min-h-[72px] sm:tw-w-[calc(100%-2.5rem)]">
          <Link to="/login" aria-label="Return to VERD sign in">
            <img src={verdLogo} alt="VERD" className="tw-block tw-h-auto tw-w-28 sm:tw-w-[132px]" />
          </Link>
          <Link
            to="/login"
            className="tw-rounded-lg tw-border tw-border-[#cfd7da] tw-px-4 tw-py-[9px] tw-text-sm tw-font-semibold tw-text-[#222a2d] tw-no-underline hover:tw-border-[#193a74] hover:tw-text-[#193a74] hover:tw-no-underline"
          >
            Sign in
          </Link>
        </div>
      </header>

      <main className="tw-mx-auto tw-w-[calc(100%-1.25rem)] tw-max-w-[960px] tw-pb-8 tw-pt-5 sm:tw-w-[calc(100%-2rem)] sm:tw-pt-12">
        <article className="tw-rounded-xl tw-border tw-border-[#e0e5e7] tw-bg-white tw-p-7 tw-shadow-[0_12px_40px_rgba(30,42,48,0.06)] sm:tw-rounded-2xl sm:tw-p-16 [&_a]:tw-text-[#193a74] [&_a]:tw-underline [&_a]:tw-underline-offset-[3px] [&_h2]:tw-mb-3 [&_h2]:tw-text-[22px] [&_h2]:tw-font-semibold [&_h2]:tw-text-[#1d2427] [&_li]:tw-mb-2 [&_li]:tw-text-base [&_li]:tw-leading-7 [&_li]:tw-text-[#485256] [&_p]:tw-mb-4 [&_p]:tw-text-base [&_p]:tw-leading-7 [&_p]:tw-text-[#485256] [&_section]:tw-mt-8 [&_strong]:tw-font-semibold [&_strong]:tw-text-[#2c3538] [&_ul]:tw-mb-4 [&_ul]:tw-list-disc [&_ul]:tw-pl-6">
          <p className="!tw-mb-2 !tw-text-[13px] !tw-font-bold !tw-uppercase !tw-tracking-[0.1em] !tw-text-[#FF9F2F]">
            Boxshall Group
          </p>
          <h1 className="tw-m-0 tw-text-2xl tw-font-bold tw-leading-tight tw-tracking-[-0.035em] tw-text-[#1d2427] sm:tw-text-2xl">
            Privacy Policy
          </h1>
          <p className="!tw-mb-6 !tw-mt-3 !tw-text-[15px] !tw-text-[#6a7478]">Effective date: 26 August 2026</p>

          <p className="!tw-mb-0 tw-border-l-4 tw-border-[#FF9F2F] tw-pl-5 !tw-text-base !tw-text-[#384347]">
            VERD is an internal workforce application operated by Boxshall Industries Pty Ltd (ABN 11 155 742 144),
            trading as Boxshall Group and VERD Developments (“Boxshall”, “we”, “us” or “our”). This policy explains how
            we handle personal information when authorised employees and contractors use VERD.
          </p>

          <section>
            <h3>Information we collect</h3>
            <p className="!tw-text-[15px]">We collect information needed to provide VERD, including:</p>
            <ul>
              <li className="!tw-text-[15px]">employee identity, contact, employment and account information</li>
              <li className="!tw-text-[15px]">
                timesheets, leave, expenses, approvals, qualifications and compliance records
              </li>
              <li className="!tw-text-[15px]">tasks, projects, comments, attachments and audit history</li>
              <li className="!tw-text-[15px]">
                company asset, vehicle and location information where tracking is enabled and
              </li>
              <li className="!tw-text-[15px]">uploaded files, usage information, device details and security logs</li>
            </ul>
            <p className="!tw-text-[15px]">
              We receive this information from you, authorised Boxshall personnel, connected business systems and
              automatically when you use VERD.
            </p>
          </section>

          <section>
            <h3>How we use information</h3>
            <p className="!tw-text-[15px]">We use information to:</p>
            <ul>
              <li className="!tw-text-[15px]">operate, secure and support VERD</li>
              <li className="!tw-text-[15px]">
                manage workforce, payroll, timesheet, leave, expense and approval processes
              </li>
              <li className="!tw-text-[15px]">
                assign and monitor tasks, projects, qualifications, assets and vehicles
              </li>
              <li className="!tw-text-[15px]">send operational notifications and</li>
              <li className="!tw-text-[15px]">
                meet workplace, safety, taxation, record-keeping and legal requirements
              </li>
            </ul>
          </section>

          <section>
            <h3>WhatsApp notifications</h3>
            <p className="!tw-text-[15px]">
              VERD uses Meta’s WhatsApp Business Platform to send work-related notifications to the mobile number in an
              employee’s profile. Messages may include the employee’s name, task title, due date, priority and a VERD
              link. VERD records message identifiers and delivery, read or failure status. Meta processes message and
              recipient information under its own terms and privacy policy.
            </p>
          </section>

          <section>
            <h3>Disclosure and service providers</h3>
            <p className="!tw-text-[15px]">
              We disclose information only where necessary to authorised Boxshall personnel, related entities and
              providers supporting VERD, including Microsoft, Intuit QuickBooks, KeyPay, DigitalOcean, Google, Flespi,
              Meta and WhatsApp. We may also disclose information where required or permitted by law. Some providers may
              process information outside Australia. We do not sell personal information or use employee information for
              third-party advertising.
            </p>
          </section>

          <section>
            <h3>Security and retention</h3>
            <p className="!tw-text-[15px]">
              We use reasonable access controls, authentication, encryption in transit and logging to protect VERD
              information. We retain records only as long as needed for business, employment and legal purposes, then
              delete or de-identify them where appropriate. Some records may need to be retained after an account or
              employment ends.
            </p>
          </section>

          <section>
            <h3>Access, correction and contact</h3>
            <p className="!tw-text-[15px]">
              You may request access to or correction of your personal information, or raise a privacy concern, subject
              to applicable law and workplace requirements.
            </p>
          </section>

          <section>
            <h3>Policy updates</h3>
            <p className="!tw-text-[15px]">
              We may update this policy when VERD, our practices or legal requirements change. The current version and
              effective date will remain available on this page.
            </p>
          </section>
        </article>
      </main>

      <footer className="tw-px-5 tw-pb-9 tw-pt-2 tw-text-center">
        <p className="tw-m-0 tw-text-[13px] tw-text-[#707a7e]">
          © 2026 Boxshall Industries Pty Ltd. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
